/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Action } from './action';
import { TeamRef } from './teamRef';
import { Stepper } from './stepper';
import { UserInfo } from './userInfo';


export interface WorkflowStep { 
    stepId: string;
    team?: TeamRef;
    stepLabel: string;
    taskStatus: string;
    placeholder?: string;
    previousStepRef?: number;
    imageData?: Array<string>;
    assignTo?: UserInfo;
    milestoneFlag?: boolean;
    optionalMilestoneFlag?: boolean;
    statefullStepFlag?: boolean;
    shareableFlag?: boolean;
    transitionInitiateStep?: boolean;
    startDate?: string;
    endDate?: string;
    actualStartDate?: string;
    actualEndDate?: string;
    plannedStartDate?: string;
    plannedEndDate?: string;
    startTime?: string;
    endTime?: string;
    minDate?: string;
    maxDate?: string;
    minTime?: string;
    maxTime?: string;
    durationInHours?: number;
    swimLane?: number;
    stepper?: Array<Stepper>;
    actions?: Array<Action>;
}

